import { render, staticRenderFns } from "./OrdersInboundDetail.vue?vue&type=template&id=5b15ca5d&scoped=true"
import script from "./OrdersInboundDetail.vue?vue&type=script&lang=js"
export * from "./OrdersInboundDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b15ca5d",
  null
  
)

export default component.exports